import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import { RESTAURANT, HOURS } from "@/data/menu";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#2A1B3D] text-[#FBF8F3] mt-20"
    >
      <div className="px-6 md:px-12 lg:px-24 py-20 grid gap-14 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <Logo dark={false} />
          <p className="mt-6 text-sm text-[#FBF8F3]/70 leading-relaxed max-w-xs">
            Authentic Indian flavors crafted with seven spices, served in the heart of
            Coral Springs.
          </p>
        </div>

        <div>
          <div className="eyebrow text-[#F5C518] mb-5">Visit</div>
          <p className="text-sm leading-relaxed flex items-start gap-2.5">
            <MapPin className="w-4 h-4 mt-0.5 text-[#1ABFB6]" />
            <span>{RESTAURANT.address}</span>
          </p>
          <p className="mt-3 text-sm flex items-center gap-2.5">
            <Phone className="w-4 h-4 text-[#1ABFB6]" />
            <a href={RESTAURANT.phoneHref} data-testid="footer-phone" className="hover:text-[#F5C518]">{RESTAURANT.phone}</a>
          </p>
          <p className="mt-3 text-sm flex items-center gap-2.5">
            <Mail className="w-4 h-4 text-[#1ABFB6]" />
            <a href={RESTAURANT.emailHref} data-testid="footer-email" className="hover:text-[#F5C518]">{RESTAURANT.email}</a>
          </p>
        </div>

        <div>
          <div className="eyebrow text-[#F5C518] mb-5">Hours</div>
          <ul className="text-sm space-y-1.5 text-[#FBF8F3]/80">
            {HOURS.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span>{h.day}</span>
                <span className="text-[#FBF8F3]/60">{h.hours}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="eyebrow text-[#F5C518] mb-5">Explore</div>
          <ul className="text-sm space-y-2.5">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-[#F5C518]">Home</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#F5C518]">About Us</Link></li>
            <li><Link data-testid="footer-link-menu" to="/menu" className="hover:text-[#F5C518]">Menu</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#F5C518]">Contact</Link></li>
          </ul>
          <div className="flex items-center gap-4 mt-8">
            <a
              href="#"
              data-testid="social-instagram"
              aria-label="Instagram"
              className="w-9 h-9 inline-flex items-center justify-center border border-[#FBF8F3]/30 hover:border-[#F5C518] hover:text-[#F5C518] transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href="#"
              data-testid="social-facebook"
              aria-label="Facebook"
              className="w-9 h-9 inline-flex items-center justify-center border border-[#FBF8F3]/30 hover:border-[#F5C518] hover:text-[#F5C518] transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#FBF8F3]/10 px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-[#FBF8F3]/50">
        <div>© {new Date().getFullYear()} 7 Spices Indian Cuisine. All rights reserved.</div>
        <div>
          Designed &amp; Developed by{" "}
          <a
            href="https://letsprint.ai"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-letsprint"
            className="text-[#F5C518] hover:text-[#FBF8F3] underline-offset-4 hover:underline transition-colors"
          >
            Lets Print
          </a>
        </div>
      </div>
    </footer>
  );
}
